type AuthProgressStepsProps = {
  currentStep: number;
  totalSteps?: number;
};

export const AuthProgressSteps = ({
  currentStep,
  totalSteps = 5,
}: AuthProgressStepsProps) => {
  return (
    <div className="auth-progress">
      <div className="auth-progress__bars">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div
            key={i}
            className={`auth-progress__bar${
              i < currentStep ? " auth-progress__bar--active" : ""
            }`}
          />
        ))}
      </div>
      <div className="auth-progress__label">
        Step {currentStep} of {totalSteps}
      </div>
    </div>
  );
};
